import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { adminEnvironment } from '../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: `${adminEnvironment.aws.cognito.oauth.domain}`,
    redirectUrl: `${adminEnvironment.aws.cognito.oauth.redirectSignIn}`,
    postLogoutRedirectUri: `${adminEnvironment.aws.cognito.oauth.redirectSignOut}`,
    clientId: `${adminEnvironment.aws.cognito.userPoolWebClientId}`,
    scope: `${adminEnvironment.aws.cognito.oauth.scope}`,
    responseType: `${adminEnvironment.aws.cognito.oauth.responseType}`,
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
  }
}
